import { CurrentUser } from '@40seas/frontend/libs/entities';
import { UserContext } from '@40seas/frontend/libs/hooks';
import { CentralizedAnimatedLoader } from '@40seas/payments-shared';
import { useEffect, useState } from 'react';
import useInitDataProvider from '../hooks/useInitDataProvider';
import DefaultDataProvider from './defaultDataProvider';

export const UserProviderGuest = ({ children, token }: { children: React.ReactNode; token: string }) => {
    const [user, setUser] = useState<CurrentUser>();
    const [loading, setLoading] = useState(true);
    const dataProvider = useInitDataProvider() as DefaultDataProvider;

    useEffect(() => {
        const loadUser = async () => {
            try {
                const response = await dataProvider.customGet(
                    'users',
                    'guest',
                    {},
                    {
                        headers: {
                            '40seas-token': token,
                        },
                    },
                );
                setUser(response.data);
            } catch (error) {
                console.error('Failed to load guest user:', error);
            } finally {
                setLoading(false);
            }
        };

        void loadUser();
    }, []);

    if (loading) {
        return <CentralizedAnimatedLoader />;
    }

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
